/* eslint-disable react/no-deprecated */
/* eslint-disable react/button-has-type */
import React from 'react';
import s from './FiltersSubmitButton.scss';
import {Loading} from '../../Loading/Loading';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../galleryGlobalStrategy';

export interface IFiltersSubmitButton extends IGalleryGlobalProps, IProvidedTranslationProps {
  closeMobileFiltersModal: Function;
}

class FiltersSubmitButtonComp extends React.Component<IFiltersSubmitButton> {
  private handleClick() {
    this.props.globals.filterProductsOnMobile();
  }

  public componentWillReceiveProps(nextProps: IFiltersSubmitButton) {
    if (this.props.globals.loading === true && nextProps.globals.loading === false) {
      this.props.closeMobileFiltersModal && this.props.closeMobileFiltersModal();
    }
  }

  public render() {
    const {
      globals: {loading},
    } = this.props;

    return (
      <button className={s.filtersSubmitButton} data-hook="filters-submit-button" onClick={() => this.handleClick()}>
        {loading ? <Loading /> : this.props.t('filtersSubmitButtonText')}
      </button>
    );
  }
}

export const FiltersSubmitButton = withGlobals(withTranslations()(FiltersSubmitButtonComp));
